module.exports = __webpack_public_path__ + "media/images/kaoawase/top/reason2-d0229dc9e29cb57477783604e3afe757.jpg";